







































































































  



  



  















      



        

















    














  




























    









            



           







              







              







              





              





              







               







              























              







              







              







              















              







              







              







            





              















              







              







              
















              







              







              







            


















import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import axios from 'axios';


import DutyPage from "./components/covfile/DutyPage";
import FilesPage from "./components/covfile/FilesPage";
import MyOrdersPage from "./components/covfile/MyOrdersPage";


import UserProfile from "./components/profile/UserProfile";
import FinalRegistration from "./components/profile/FinalRegistration";

import Login from "./components/login/Login";
import ForgotPassword from "./components/login/ForgotPassword";
import ResetPassword from "./components/login/ResetPassword";



import HeaderU from "./components/header/HeaderU";
import HeaderA from "./components/header/HeaderA";
import RestForm from "./components/rest/RestoForm";
import SystemsFabricsManager from "./components/covfile/SystemsFabricsManager";
import ExcelEditor from "./components/covfile/ExcelEditor";
import EmailSettingsPage from "./components/covfile/EmailSettingsPage";
import ExchangeRateSettings from "./components/covfile/ExchangeRateSettings";
import AllOrdersPage from "./components/covfile/AllOrdersPage";
import PriceChange from "./components/covfile/PriceChange";
import FilesManager from "./components/covfile/FilesManager";
import UserManagement from "./components/rest/UserManagement";


import { useAuth } from './components/auth/Auth';
import { AuthProvider } from './components/auth/Auth';
import Directory from "./components/directory/Directory";





const API_BASE_URL = 'https://test2.planfix-to-syrve.com';


function ProtectedRoute({ children, allowedRule }) {
  const { user } = useAuth();
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (!user?.user_id) {
        setLoading(false);
        return;
      }
      try {
        const response = await axios.get(`${API_BASE_URL}/api/user-role-file/${user.user_id}`);
        if (response.data.success) {
          setUserRole(response.data.role);
        } else {
          setUserRole('0');
        }
      } catch (error) {
        console.error('Error fetching user role:', error);
        setUserRole('0');
      } finally {
        setLoading(false);
      }
    };
    
    fetchUserRole();
  }, [user?.user_id]);

  if (loading) {
    return <div>Завантаження...</div>;
  }

  const isAllowed = String(userRole) === String(allowedRule);
  
  if (!isAllowed) {
    return <Navigate to="/" replace />;
  }
  
  return children;
}


function RoleBasedRoute({ children, allowedRoles }) {
  const { user } = useAuth();
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (!user?.user_id) {
        setLoading(false);
        return;
      }
      try {
        const response = await axios.get(`${API_BASE_URL}/api/user-role-file/${user.user_id}`);
        if (response.data.success) {
          setUserRole(response.data.role);
        } else {
          setUserRole('0');
        }
      } catch (error) {
        console.error('Error fetching user role:', error);
        setUserRole('0');
      } finally {
        setLoading(false);
      }
    };
    fetchUserRole();
  }, [user?.user_id]);

  if (loading) {
    return <div>Завантаження...</div>;
  }

  const isAllowed = userRole && allowedRoles.includes(userRole);
  if (!isAllowed) {
    return <Navigate to="/" replace />;
  }
  return children;
}


function ChooseHeader() {
  const { user } = useAuth();
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (!user?.user_id) {
        setLoading(false);
        return;
      }
      try {
        const response = await axios.get(`${API_BASE_URL}/api/user-role-file/${user.user_id}`);
        if (response.data.success) {
          setUserRole(response.data.role);
        } else {
          setUserRole('0');
        }
      } catch (error) {
        console.error('Error fetching user role:', error);
        setUserRole('0');
      } finally {
        setLoading(false);
      }
    };
    fetchUserRole();
  }, [user?.user_id]);

  if (loading) {
    return null;
  }

  if (userRole === '3' || userRole === 3) {
    return null;
  }

  if (userRole === '1' || userRole === 1) {
    return <HeaderA />;
  }
  return <HeaderU />;
}


function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div>Завантаження...</div>;
  }
  
  if (!user) {
    return <Navigate to="/Login" replace />;
  }
  
  return children;
}


function RootRedirect() {
  const { user, loading } = useAuth();
  const [userRole, setUserRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);

  useEffect(() => {
    const fetchUserRoleFromFile = async () => {
      if (!user?.user_id) {
        setRoleLoading(false);
        return;
      }
      
      try {
        console.log('Отримання ролі для userId:', user.user_id);
        const response = await axios.get(`${API_BASE_URL}/api/user-role-file/${user.user_id}`);
        
        if (response.data.success) {
          const role = response.data.role;
          console.log('Отримано роль з файлу:', role);
          setUserRole(role);
          localStorage.setItem('userRole', role);
        } else {
          console.error('Помилка отримання ролі');
          setUserRole('0');
        }
      } catch (error) {
        console.error('Помилка запиту ролі:', error);
        setUserRole('0');
      } finally {
        setRoleLoading(false);
      }
    };
    
    if (!loading) {
      fetchUserRoleFromFile();
    }
  }, [user, loading]);

  if (loading || roleLoading) {
    return <div>Завантаження...</div>;
  }

  if (!user) {
    return <Navigate to="/Login" replace />;
  }

  console.log('Фінальна роль для редіректу:', userRole);
  
  
  if (userRole === '1' || userRole === 1) {
    console.log('АДМІН: редірект на /AllOrdersPage');
    return <Navigate to="/AllOrdersPage" replace />;
  } 
  
  else if (userRole === '3' || userRole === 3) {
    console.log('КОРИСТУВАЧ З РОЛЛЮ 3: редірект на FinalRegistration');
    return <Navigate to="/FinalRegistration" replace />;
  } 
  
  else {
    console.log('КОРИСТУВАЧ: редірект на /DutyPage');
    return <Navigate to="/DutyPage" replace />;
  }
}

function App() {
  
  useEffect(() => {
    const initUserRole = async () => {
      const userId = localStorage.getItem('userId');
      if (userId) {
        try {
          await axios.get(`${API_BASE_URL}/api/user-role-file/${userId}`);
          console.log('Ініціалізовано файл ролі для користувача:', userId);
        } catch (error) {
          console.error('Помилка ініціалізації файлу ролі:', error);
        }
      }
    };
    
    initUserRole();
  }, []);

  return (
    <BrowserRouter>
      <div className="forFooter">
        <div className="App">
          <AuthProvider>
            <ChooseHeader />
            
            <Routes>
              {}
              <Route path="/" element={<RootRedirect />} />
           
       
              
          
      
              
              <Route path="/DutyPage" element={
                <RequireAuth>
                  <DutyPage />
                </RequireAuth>
              } />
       <Route path="/files/:folderName" element={<FilesPage />} />

              
              <Route path="/MyOrdersPage" element={
                <RequireAuth>
                  <MyOrdersPage />
                </RequireAuth>
              } />
     
      
              
    

              
              <Route path="/Directory" element={
                <RequireAuth>
                  <ProtectedRoute allowedRule="1">
                    <Directory />
                  </ProtectedRoute>
                </RequireAuth>
              } />
              
  
        
            
              <Route path="/UserProfile" element={
                <RequireAuth>
                  <UserProfile />
                </RequireAuth>
              } />
              
              {}
              <Route path="/FinalRegistration" element={
                <RequireAuth>
                  <ProtectedRoute allowedRule="3">
                    <FinalRegistration />
                  </ProtectedRoute>
                </RequireAuth>
              } />

     
              <Route path="/Login" element={<Login />} />
              <Route path="/ForgotPassword" element={<ForgotPassword />} />
              <Route path="/ResetPassword/:token" element={<ResetPassword />} />
              <Route path="/ResetPassword" element={<ResetPassword />} />
           
              
              <Route path="/RestForm" element={
                <RequireAuth>
                  <ProtectedRoute allowedRule="1">
                    <RestForm />
                  </ProtectedRoute>
                </RequireAuth>
              } />
              
              <Route path="/SystemsFabricsManager" element={
                <RequireAuth>
                  <ProtectedRoute allowedRule="1">
                    <SystemsFabricsManager />
                  </ProtectedRoute>
                </RequireAuth>
              } />
              
              <Route path="/ExcelEditor" element={
                <RequireAuth>
                  <ProtectedRoute allowedRule="1">
                    <ExcelEditor />
                  </ProtectedRoute>
                </RequireAuth>
              } />

              <Route path="/EmailSettingsPage" element={
                <RequireAuth>
                  <ProtectedRoute allowedRule="1">
                    <EmailSettingsPage />
                  </ProtectedRoute>
                </RequireAuth>
              } />
                 <Route path="/ExchangeRateSettings" element={
                <RequireAuth>
                  <ProtectedRoute allowedRule="1">
                    <ExchangeRateSettings/>
                  </ProtectedRoute>
                </RequireAuth>
              } />
              
              <Route path="/AllOrdersPage" element={
                <RequireAuth>
                  <ProtectedRoute allowedRule="1">
                    <AllOrdersPage />
                  </ProtectedRoute>
                </RequireAuth>
              } />
              
                 <Route path="/PriceChange" element={
                <RequireAuth>
                  <ProtectedRoute allowedRule="1">
                    <PriceChange />
                  </ProtectedRoute>
                </RequireAuth>
              } />
                    <Route path="/FilesManager" element={
                <RequireAuth>
                  <ProtectedRoute allowedRule="1">
                    <FilesManager/>
                  </ProtectedRoute>
                </RequireAuth>
              } />
              <Route path="/UserManagement" element={
                <RequireAuth>
                  <ProtectedRoute allowedRule="1">
                    <UserManagement />
                  </ProtectedRoute>
                </RequireAuth>
              } />
              
           
            
            </Routes>
          </AuthProvider>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
